import { useState } from 'react';
import { supabase } from '../services/supabaseClient';

export const useSupport = () => {
  const [loading, setLoading] = useState(false);

  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
  });

  const generateHtmlTemplate = (payload) => `
    <!DOCTYPE html>
    <html lang="es">
    <head><meta charset="UTF-8"></head>
    <body style="margin: 0; padding: 0; background-color: #f4f4f4; font-family: Arial, sans-serif;">
        <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#f4f4f4">
            <tr>
                <td align="center" style="padding: 20px 0;">
                    <table width="600" border="0" cellspacing="0" cellpadding="0" bgcolor="#ffffff" style="border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
                        <tr height="4"><td style="background: linear-gradient(to right, #ff8b00, #ffb347, #ff8b00);"></td></tr>
                        <tr>
                            <td bgcolor="#0f0f0f" align="center" style="padding: 25px 20px;">
                                <h1 style="color: #ffffff; margin: 0; font-size: 22px; letter-spacing: 2px; text-transform: uppercase; font-weight: 900;">MSC Rewards</h1>
                                <span style="color: #ff8b00; font-size: 10px; letter-spacing: 4px; font-weight: bold;">PLATAFORMA DE COMERCIOS ALIADOS</span>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding: 40px 30px; color: #333333; line-height: 1.6;">
                                <h2 style="font-size: 18px; margin-top: 0; color: #0f0f0f; border-bottom: 2px solid #f4f4f4; padding-bottom: 10px;">Nuevo Ticket de Requerimiento</h2>
                                <table width="100%" border="0" cellspacing="0" cellpadding="0" style="margin: 20px 0; background-color: #fafafa; border-radius: 6px;">
                                    <tr>
                                        <td style="padding: 15px; font-size: 14px;">
                                            <div style="margin-bottom: 8px;"><strong>Empresa:</strong> <span style="color: #ff8b00;">${payload.enterprise}</span></div>
                                            <div style="margin-bottom: 8px;"><strong>Remitente:</strong> ${payload.user_email}</div>
                                            <div style="margin-bottom: 8px;"><strong>Teléfono:</strong> ${payload.phone}</div>
                                            <div><strong>Categoría:</strong> <span style="background: #0f0f0f; color: #fff; padding: 2px 8px; border-radius: 4px; font-size: 11px;">${payload.type.toUpperCase()}</span></div>
                                        </td>
                                    </tr>
                                </table>
                                <div style="background-color: #fff8f0; border-left: 4px solid #ff8b00; padding: 20px; margin: 20px 0;">
                                    <strong style="display: block; margin-bottom: 10px; color: #0f0f0f; font-size: 14px;">Descripción del Caso:</strong>
                                    <p style="margin: 0; font-size: 15px; color: #444; white-space: pre-wrap;">${payload.message}</p>
                                </div>
                                <p style="font-size: 12px; color: #777; text-align: center; margin-top: 30px;">Este es un mensaje automático generado desde el Portal de Aliados.</p>
                            </td>
                        </tr>
                        <tr>
                            <td bgcolor="#fcfcfc" style="padding: 20px; color: #999; text-align: center; font-size: 11px; border-top: 1px solid #eeeeee;">
                                <strong>MSC Rewards – SOGEMSA</strong><br>
                                &copy; 2026 Gestión Operativa de Socios Estratégicos.
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </body>
    </html>
  `;

  const sendTicket = async (payload, files) => {
    setLoading(true);
    try {
      const attachments = [];
      if (files?.length > 0) {
        for (const file of files) {
          const base64Content = await fileToBase64(file);
          attachments.push({
            content: base64Content,
            filename: file.name,
            type: file.type,
            disposition: 'attachment'
          });
        }
      }

      const { error: dbError } = await supabase.from('support_tickets').insert([{
        user_email: payload.user_email,
        enterprise: payload.enterprise,
        phone: payload.phone,
        type: payload.type,
        message: payload.message
      }]);

      if (dbError) throw dbError;

      const htmlContent = generateHtmlTemplate(payload);
      const textContent = `Ticket de ${payload.enterprise}\nEmail: ${payload.user_email}\nTel: ${payload.phone}\n\nMensaje: ${payload.message}`;

      const { error: rpcError } = await supabase.rpc('send_support_ticket', { 
        payload: {
          subject: `[SOPORTE] ${payload.enterprise} - ${payload.type.toUpperCase()}`,
          html: htmlContent,
          message: htmlContent, 
          text: textContent,
          attachments: attachments
        }
      });

      if (rpcError) throw rpcError;
      return { success: true };

    } catch (err) {
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  return { sendTicket, loading };
};